import {
  IconHome,
  IconInvoice,
  IconUser,
  IconWarning,
  type IconComponent
} from '@gat-ship/icons'
import type { StakeholderType } from '@gat-ship/types'

/** The sidebar tabs of the stakeholder detail modal. */
export const STAKEHOLDER_DETAIL_SECTIONS = [
  'general',
  'billing',
  'contacts',
  'danger-zone'
] as const

export type StakeholderDetailSection =
  (typeof STAKEHOLDER_DETAIL_SECTIONS)[number]

export interface StakeholderDetailSidebarItem {
  key: StakeholderDetailSection
  label: string
  icon: IconComponent
}

/**
 * Sidebar items for a stakeholder of the given type — mirrors the routed
 * sub-menu (`stakeholders-text.ts` `subMenu`): General, Billing (clients
 * only), Contacts, Danger Zone.
 */
export function getStakeholderDetailSidebarItems(
  stakeholderType: StakeholderType
): StakeholderDetailSidebarItem[] {
  const items: StakeholderDetailSidebarItem[] = [
    { key: 'general', label: 'General', icon: IconHome }
  ]
  if (stakeholderType === 'client') {
    items.push({ key: 'billing', label: 'Billing', icon: IconInvoice })
  }
  items.push({ key: 'contacts', label: 'Contacts', icon: IconUser })
  items.push({ key: 'danger-zone', label: 'Danger Zone', icon: IconWarning })
  return items
}

/** Validate a raw query value into a known section, defaulting to `general`. */
export function toValidStakeholderSection(
  value: string | null
): StakeholderDetailSection {
  return STAKEHOLDER_DETAIL_SECTIONS.includes(value as StakeholderDetailSection)
    ? (value as StakeholderDetailSection)
    : 'general'
}
